import axios from "../config/axios"

const API_BASE = "/on-contracts"

export const onContractService = {
  // Get all contracts (optional ?vehicle_id=)
  getAll: (filters = {}) => {
    return axios.get(API_BASE, { params: filters })
  },

  // Get single contract
  getOne: (contractId) => {
    return axios.get(`${API_BASE}/${contractId}`)
  },

  // Get ML sheets for a vehicle that are NOT yet in any contract
  getAvailableMLSheets: (vehicleId) => {
    return axios.get(`${API_BASE}/available_ml_sheets`, { params: { vehicle_id: vehicleId } })
  },

  // Get aggregated data (shipment count + revenue) for selected ML sheet IDs
  getMLSheetData: (mlSheetIds = []) => {
    return axios.get(`${API_BASE}/ml_sheet_data`, {
      params: { ml_sheet_ids: mlSheetIds.join(",") },
    })
  },

  // Create new contract
  create: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update contract (full or partial)
  update: (contractId, data) => {
    return axios.put(`${API_BASE}/${contractId}`, data)
  },

  // Update only charges and get new trip_pl
  updateCharges: (contractId, data) => {
    return axios.patch(`${API_BASE}/${contractId}/charges`, data)
  },

  // Delete contract
  delete: (contractId) => {
    return axios.delete(`${API_BASE}/${contractId}`)
  },

  // Get all vehicles without pagination (reuse from mlSheetService pattern)
  getAllVehicles: () => {
    return axios.get("/vehicles", { params: { all: true } })
  },
}